// extracted by mini-css-extract-plugin
module.exports = {"AppBorderedPanel":"AppBorderedPanel_dIp6R"};